// extracted by mini-css-extract-plugin
export default {"keypad":"KeyPad_keypad__spDGF"};